import { c as _c } from "react/compiler-runtime";
import { AppBar as MuiAppBar, Toolbar } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Typography from '@classify/react-core-components/Typography';
export const styles = /* istanbul ignore next */({
  spacing,
  breakpoints
}) => ({
  root: {
    flexGrow: 1
  },
  flex: {
    flexGrow: 1
  },
  navigationIcon: {
    marginLeft: -12,
    marginRight: 20
  },
  prominent: {
    minHeight: 128,
    alignItems: 'flex-start',
    paddingTop: spacing(1)
  },
  toolbar: {
    padding: `0 ${spacing(2)}`
  },
  headline: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    paddingBottom: spacing(2),
    marginTop: spacing(1)
  },
  headlineProminent: {
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  actionItems: {
    alignSelf: 'flex-start',
    marginTop: spacing(1)
  }
});
export const AppBar = t0 => {
  const $ = _c(42);
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t0) {
    ({
      actionItems: t1,
      children: t2,
      classes: t3,
      isProminent: t4,
      navigationIcon: t5,
      title: t6,
      titleProps: t7,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t1) {
    t8 = t1 === undefined ? [] : t1;
    $[9] = t1;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const actionItems = t8;
  const children = t2 === undefined ? null : t2;
  let t9;
  if ($[11] !== t3) {
    t9 = t3 === undefined ? {} : t3;
    $[11] = t3;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const classes = t9;
  const isProminent = t4 === undefined ? false : t4;
  const navigationIcon = t5 === undefined ? null : t5;
  const title = t6 === undefined ? "" : t6;
  let t10;
  if ($[13] !== t7) {
    t10 = t7 === undefined ? {} : t7;
    $[13] = t7;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const titleProps = t10;
  let t11;
  if ($[15] !== classes.navigationIcon || $[16] !== navigationIcon) {
    t11 = navigationIcon ? <div className={classes.navigationIcon}>{navigationIcon}</div> : null;
    $[15] = classes.navigationIcon;
    $[16] = navigationIcon;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const leftIcon = t11;
  const t12 = `${classes.toolbar || ""} ${isProminent ? classes.prominent : ""}`;
  const t13 = `${classes.headline} ${isProminent ? classes.headlineProminent : ""}`;
  let t14;
  if ($[18] !== classes.flex || $[19] !== title || $[20] !== titleProps) {
    t14 = typeof title === "string" ? <Typography className={classes.flex} color="inherit" variant="h2" {...titleProps}>{title}</Typography> : title;
    $[18] = classes.flex;
    $[19] = title;
    $[20] = titleProps;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== leftIcon || $[23] !== t14) {
    t15 = <div>{leftIcon}{t14}</div>;
    $[22] = leftIcon;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15) {
    t16 = <div className={t13}>{t15}</div>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== actionItems || $[29] !== classes.actionItems) {
    t17 = <div className={classes.actionItems}>{actionItems}</div>;
    $[28] = actionItems;
    $[29] = classes.actionItems;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t12 || $[32] !== t16 || $[33] !== t17) {
    t18 = <Toolbar className={t12}>{t16}{t17}</Toolbar>;
    $[31] = t12;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== children || $[36] !== otherProps || $[37] !== t18) {
    t19 = <MuiAppBar {...otherProps}>{t18}{children}</MuiAppBar>;
    $[35] = children;
    $[36] = otherProps;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== classes.root || $[40] !== t19) {
    t20 = <div className={classes.root}>{t19}</div>;
    $[39] = classes.root;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
};
export default withStyles(styles)(AppBar);